import classNames from "classnames";
import styles from "./styles.module.scss";
import { useState, useEffect } from "react";
import { useMaintenance } from "src/store/maintenance.state";

const Nav = ({
  onChange,
  items,
  defaultIndex = 0,
  UserGuide,
  step,
}: {
  onChange: (index: number) => void;
  items: { icon: string; label: string }[];
  defaultIndex?: number;
  UserGuide?: boolean;
  step?: number;
}) => {
  const [activeNavIndex, setActiveNavIndex] = useState(defaultIndex);
  const { maintenance } = useMaintenance();

  const handleClick = (index: number) => {
    setActiveNavIndex(index);
    onChange(index);
  };

  useEffect(() => {
    if (UserGuide) {
      if (step === 3) {
        setActiveNavIndex(1);
      } else if (step === 6) {
        setActiveNavIndex(2);
      } else {
        console.log("error");
      }
    } else {
      setActiveNavIndex(0);
    }
  }, [step, UserGuide]);

  return (
    <ul className={styles.nav}>
      {items.map((widget) => {
        if (widget.label === "Settings" && !maintenance) {
          return null;
        }

        const isActive =
          items.findIndex((w) => w.label === widget.label) === activeNavIndex;
        const listItemClasses = classNames(styles.nav__item, {
          [styles["nav__item--active"]]: isActive,
        });

        return (
          <li key={widget.label} className={listItemClasses}>
            <button
              type="button"
              className={styles.nav__button}
              onClick={() =>
                handleClick(items.findIndex((w) => w.label === widget.label))
              }
            >
              <img src={widget.icon} alt="" />
              <span>{widget.label}</span>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default Nav;
